<template lang='pug'>
  div(class='fullness-line-chart' )
</template>
<script>
import echarts from 'echarts/lib/echarts'

// import the util you want
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/graphic'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/axis'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/markLine'
export default {
  props: {
    fullness: Number,
    index: Number
  },

  /**
   * 折线（区域）图、柱状（条形）图: a（系列名称），b（类目值），c（数值）, d（无）
   */

  data () {
    return {
      echarts,
      lineChart: null,
      months: [
        '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'
      ],
      option: {
        tooltip: {
          show: false
        },
        xAxis: {
          show: false,
          data: []
        },
        grid: {
          left: '0%',
          top: '10%',
          right: '0%',
          bottom: '3%'
        },
        yAxis: {
          max: 100,
          min: 0,
          axisTick: false,
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false,
            formatter: '{value}'
          },
          splitLine: {
            show: false
          }
        },
        series: [

        ],
        color: ['#189f96', '#FEBF04', '#0563EF']
      }
    }
  },
  mounted () {
    this.lineChart = this.echarts.init(document.getElementsByClassName('fullness-line-chart')[this.index])
    this.option.series.push({
      name: '容量',
      type: 'line',
      data: [this.getRandomNum(1, 7), this.getRandomNum(7, 15), this.getRandomNum(15, 22), this.getRandomNum(22, 30), this.getRandomNum(30, 40), this.getRandomNum(40, 50), this.getRandomNum(50, this.fullness), this.fullness],
      smooth: 'spline',
      showSymbol: false,
      itemStyle: {
        normal: {
          lineStyle: {
            color: this.setColor(this.fullness),
            width: 1
          },
          areaStyle: {
            opacity: 0.1,
            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
              offset: 0,
              color: this.setColor(this.fullness)
            }, {
              offset: 1,
              color: this.setColor(this.fullness)
            }])
          }
        }
      }
    })
    this.lineChart.setOption(this.option)
  },
  methods: {
    getRandomNum (min, max) {
      return Math.random() * (max - min) + min
    },
    setColor (percentage) {
      if (percentage > 60) {
        return '#EA6767'
      } else {
        return '#189f96'
      }
    }
  }
}
</script>

<style scoped lang='scss'>
@import "@/assets/scss/helper/variables.scss";

.fullness-line-chart {
  height: 100%;
  width: 100%;
}
</style>
